import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './restaurant_v2/Header';
import Footer from './restaurant_v2/Footer';
import Home from './restaurant_v2/Home';
import Carte from './restaurant_v2/Carte';
import Cuisine from './restaurant_v2/Cuisine';
import Reserver from './restaurant_v2/Reserver';

export default function RestaurantTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#F1ECDF]" data-testid="resto-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`resto-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'carte' && <Carte setPage={setPage} />}
          {page === 'cuisine' && <Cuisine setPage={setPage} />}
          {page === 'reserver' && <Reserver setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
